require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/urlParameter.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/urlParameter.legacy.js
// module id = 620
// module chunks = 31